export default [
  {
    component: () => import('./pages/Default.vue'),
    meta: {
      metaTags: [
        {
          content: '',
          name: 'description',
        },
        {
          page_slug: 'product-research',
        },
      ],
      requiresAuth: true,
      title: 'eRank — Product Research',
    },
    name: 'product-research',
    path: '/product-research',
  },
  // Intentionally disabled until the Product Research DAL is available (ER-4694).
  // {
  //   component: () => import('./pages/Entry.vue'),
  //   meta: {
  //     metaTags: [
  //       {
  //         content: '',
  //         name: 'description',
  //       },
  //       {
  //         page_slug: 'product-research-tool',
  //       },
  //     ],
  //     requiresAuth: true,
  //     title: 'eRank — Product Research Tool',
  //   },
  //   name: 'product-research-tool',
  //   path: '/product-research-tool',
  // },
];
